import {
  SCREENSHOTS,
  UPDATE_SCREENSHOTS,
  PROMO_SCREENSHOTS,
  UPDATE_PROMO_SCREENSHOTS,
  RESET,
} from '../../types';

import { Apps } from '@/api/api';

// empty list means 'no screenshots uploaded yet'
// use null over an empty array, so that we can check
// if we have already fetched the data or not
export const state = () => ({
  screenshots: null,
  promoScreenshots: null,
});

export const getters = {
  [SCREENSHOTS]({ screenshots }) {
    return screenshots;
  },
  [PROMO_SCREENSHOTS]({ promoScreenshots }) {
    return promoScreenshots;
  },
};

/* eslint-disable no-param-reassign */
export const mutations = {
  [SCREENSHOTS](stateObj, screenshots) {
    stateObj.screenshots = screenshots;
  },
  [PROMO_SCREENSHOTS](stateObj, promoScreenshots) {
    stateObj.promoScreenshots = promoScreenshots;
  },
  [RESET](stateObj) {
    Object.assign(stateObj, state());
  },
};

export const actions = {
  [SCREENSHOTS]({ commit }, packageName) {
    return Apps.getScreenshots({ packageName })
      .then(({ body: { screenshots = [] } }) => {
        commit(SCREENSHOTS, [...screenshots]);
      })
      .catch(({ body: { message = '' } = {} }) => Promise.reject(message));
  },

  [PROMO_SCREENSHOTS]({ commit }, packageName) {
    return Apps.getPromoScreenshots({ packageName })
      .then(({ body: { screenshots = [] } }) => {
        commit(PROMO_SCREENSHOTS, [...screenshots]);
      })
      .catch(({ body: { message = '' } = {} }) => Promise.reject(message));
  },

  [UPDATE_SCREENSHOTS]({ commit }, { packageName, list }) {
    return Apps.updateScreenshots({ packageName }, { screenshots: list })
      .then(({ body: { screenshots = [], message = '' } }) => {
        commit(SCREENSHOTS, [...screenshots]);
        return Promise.resolve(message);
      })
      .catch(({ body: { message = '' } = {} }) => Promise.reject(message));
  },
  [UPDATE_PROMO_SCREENSHOTS]({ commit }, { packageName, list }) {
    return Apps.updatePromoScreenshots({ packageName }, { screenshots: list })
      .then(({ body: { screenshots = [], message = '' } }) => {
        commit(PROMO_SCREENSHOTS, [...screenshots]);
        return Promise.resolve(message);
      })
      .catch(({ body: { message = '' } = {} }) => Promise.reject(message));
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
